import type { ReactNode } from 'react';
import { createBrowserHistory, Router } from 'react-resource-router';
import { createResourcesPlugin } from 'react-resource-router/resources';

import { createAppRoutes } from '../../../routes';
import { useUserPermData } from '../../../utils/user-perm-context';

export const LazyAppRouter = ({ children }: { children: ReactNode }) => {
	const { rovoDevAgentsUser } = useUserPermData();
	return (
		<Router
			routes={createAppRoutes(
				rovoDevAgentsUser.isAdmin,
				rovoDevAgentsUser.userSiteHasActiveDevAiEntitlement,
			)}
			history={history}
			plugins={[resourcesPlugin]}
			basePath="/dev-agents"
		>
			{children}
		</Router>
	);
};

const history = createBrowserHistory();
const resourcesPlugin = createResourcesPlugin({
	resourceData: undefined,
});
